import { useState, Fragment, useRef, useEffect } from 'react';
import '../../assets/css/account.css'
import { TrashIcon } from '@heroicons/react/outline';
import Layout from './../../components/Layout/Layout';
import React from "react";
import AccountServices from '../../services/AccountServices';
import { Dialog, Transition } from '@headlessui/react'
import fire from './../../utils/Toastr';
import { formatDate } from '../../utils/convertDate';
import { convert } from './../../utils/convertDate';
import { HollowDotsSpinner } from 'react-epic-spinners';



export default function MinorView() {

  const id = new URLSearchParams(window.location.search).get("id");
  const errors = {
    commentError: "",
    commentIsValidated: false,
    formIsSubmitting: false
  }
  const [open, setOpen] = useState(false)

  const cancelButtonRef = useRef(null)
  const [acct, setAcct] = useState({});
  const [openReject, setRejectOpen] = useState(false);
  const [commentValue, setCommentValue] = useState({
    comment: ""
  });
  const [formState, setFormState] = useState(errors);
  const [minorId, setMinorId] = useState("");
  const [parentDetails, SetParentDetails] = useState("");
  const [loading, setLoading] = useState({ loading: false })

  const listDocument = async () => {
    const resp = await AccountServices.viewMinor(id);
    if (resp) {
      setAcct(resp.data)
      SetParentDetails(resp.data.parentDetails);
    }
  }
  // comment validation
  const formHandler = {

    commentHandler: (event) => {
      setCommentValue({ ...commentValue, comment: event.target.value });
      if (event.target.value.trim().length < 1) {
        setFormState({
          ...formState,
          commentError: "Comment cannot be empty",
          commentIsValidated: false,
        });
        return;
      }

      setFormState({
        ...formState,
        commentError: "",
        commentIsValidated: true
      })
    },
  }
  const approve = async () => {
    setLoading({ loading: true });
    const isFiiled = formState.commentIsValidated;
    if (commentValue.comment === "") {
      setLoading({ loading: false });
      setFormState({
        ...formState,
        commentError: "Field cannot be empty",
        commentIsValidated: false,
      });
      return;
    }
    setFormState({ ...formState, formIsSubmitting: true });
    if (!isFiiled) {
      fire("error", "Field is required");
      return;

    }
    const resp = await AccountServices.actionMinor({ id: minorId, actionStatus: "Approved", comment: commentValue.comment })
    if (resp) {
      fire("success", resp.message)
      setTimeout(() => {
        window.location.reload();
        window.location.href = "/minor/accounts"
      }, 5000);
    }


    setLoading({ loading: false });


  }
  const reject = async () => {
    setLoading({ loading: true });
    const isFiiled = formState.commentIsValidated
    if (commentValue.comment === "") {
      setFormState({
        ...formState,
        commentError: "Field cannot be empty",
        commentIsValidated: false,
      });
      setLoading({ loading: false });
      return;

    }
    setFormState({ ...formState, formIsSubmitting: true });
    if (!isFiiled) {
      fire("error", "Field is required");
      return;
    }
    const resp = await AccountServices.actionMinor({ id: minorId, actionStatus: "Rejected", comment: commentValue.comment })
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
        window.location.href = "/minor/accounts"
      }, 5000);
    }



    setLoading({ loading: true });
  }

  // comments Modal
  const handleApprove = async (person) => {
    setOpen(true);
    setMinorId(person.id);

  }
  const handleReject = async (person) => {
    setRejectOpen(true);
    setMinorId(person.id);
  }
  const handleClose = () => {
    setOpen(false);

  }
  const handleRejectClose = () => {
    setRejectOpen(false);
  }



  //  const updateInfo =  async () => {
  //   const resp = await AccountServices.personalInfo(id);
  //  }
  useEffect(() => {
    listDocument();
  }, [])
  return (<>

    <Layout title="" pageTag={'account'} current={'/view/minor'}>
      <React.Fragment>
        <main>
          <div className='max-w-7xl mx-auto'>
            <div className=''>

              <div className='flex justify-center'><h4 className='font-bold'>{acct.lastName} {acct.firstName} <br /> <span className='font-thin'>{acct.accountNumber}</span></h4></div>

              <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto flex">
                    <div className="mt-1 relative">
                      <h2 className="font-semibold text-gray-900">Customer's Uploads</h2>
                    </div>
                  </div>
                </div>
                <div className="mt-8 flex flex-col">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                      <ul className='grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
                        <li className="col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200">
                          <div className="flex-1 flex flex-col p-8">
                            <div className="flex">
                              <img className="w-32 h-32 flex-shrink-0 mx-auto" src={acct.passportPhotoUrl} alt="" />
                            </div>
                          </div>
                          <p>Passport</p>
                        </li>
                        <li className="col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200">
                          <div className="flex-1 flex flex-col p-8">
                            <div className="flex">
                              <img className="w-32 h-32 flex-shrink-0 mx-auto" src={acct.birthCertificateUrl} alt="" />
                            </div>
                          </div>
                          <p>Birth Certificate</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Required details */}
                <div className="mt-8 flex flex-col">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                      <form>

                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                          <div className='inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white'>
                            {/* form */}
                            <div className='px-6'>
                              <h4>PERSONAL INFORMATION</h4>
                              <div className='mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6'>
                                <div className="sm:col-span-2">
                                  <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
                                    Surname <span className='text-red-600'>*</span>
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="lastName" id="lastName" value={acct.lastName} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
                                    First Name <span className='text-red-600'>*</span>
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="firstName" id="firstName" value={acct.firstName} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
                                    Middle Name
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="firstName" id="firstName" value={acct.middleName} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="dob" className="block text-sm font-medium text-gray-700">
                                    Date of Birth
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="dob" id="dob" value={formatDate(acct.dateofBirth)} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-1">
                                  <label htmlFor="gender" className="block text-sm font-medium text-gray-700">
                                    Gender
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="gender" id="gender" value={acct.gender} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="mother" className="block text-sm font-medium text-gray-700">
                                    Minor's Mother's Maiden Name
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="mother" id="mother" value={acct.motherMaidenName} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                                    Account Status
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="phone" id="phone" value={acct.accountStatus} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>

                                <div className="sm:col-span-2">
                                  <label htmlFor="nationality" className="block text-sm font-medium text-gray-700">
                                    Date Created
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="nationality" id="nationality" value={convert(acct.dateCreated)} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                          <div className='inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white'>
                            {/* form */}
                            <div className='px-6'>
                              <h4>PARENT DETAILS</h4>
                              <div className='mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6'>
                                <div className="sm:col-span-2">
                                  <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
                                    Title <span className='text-red-600'>*</span>
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="lastName" id="lastName" value={parentDetails === null ? "" : parentDetails.title} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
                                    Surname <span className='text-red-600'>*</span>
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="lastName" id="lastName" value={parentDetails === null ? "" : parentDetails.surname} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
                                    First Name <span className='text-red-600'>*</span>
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="firstName" id="firstName" value={parentDetails === null ? "" : parentDetails.firstName} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-700">
                                    Date of Birth
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="dateOfBirth" id="dateOfBirth" value={parentDetails === null ? "" : formatDate(parentDetails.dateOfBirth)} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="gender" className="block text-sm font-medium text-gray-700">
                                    Gender
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="gender" id="gender" value={parentDetails === null ? "" : parentDetails.gender} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="maritalStatus" className="block text-sm font-medium text-gray-700">
                                    Marital Status
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="maritalStatus" id="maritalStatus" value={parentDetails === null ? "" : parentDetails.maritalStatus} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="bvn" className="block text-sm font-medium text-gray-700">
                                    BVN
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="bvn" id="bvn" value={parentDetails === null ? "" : parentDetails.bvn} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="state" className="block text-sm font-medium text-gray-700">
                                  Residential State 
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="state" id="state" value={parentDetails === null ? "" : parentDetails.state} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="lga" className="block text-sm font-medium text-gray-700">
                                   Residential Local Government Area
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="lga" id="lga" value={parentDetails === null ? "" : parentDetails.lga} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="state" className="block text-sm font-medium text-gray-700">
                                 State of Origin
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="state" id="state" value={acct === null ? "" : acct.parentStateOfOrigin} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="lga" className="block text-sm font-medium text-gray-700">
                                  State of Origin LGA
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="lga" id="lga" value={acct === null ? "" : acct.parentStateOfOriginLGA} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label htmlFor="emailAddress" className="block text-sm font-medium text-gray-700">
                                    Email Address
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="emailAddress" id="emailAddress" value={parentDetails === null ? "" : parentDetails.emailAddress} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                                <div className="sm:col-span-4">
                                  <label htmlFor="residentialAddress" className="block text-sm font-medium text-gray-700">
                                    Residential Address
                                  </label>
                                  <div className="mt-1">
                                    <input type="text" name="residentialAddress" id="residentialAddress" value={parentDetails === null ? "" : parentDetails.residentialAddress} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                  </div>
                                </div>
                               
                              </div>
                            </div>
                          </div>
                        </div>
                        {acct.accountStatus === "Pending" ?
                          <>
                            <div className='flex justify-end bg-white p-6'>
                              <button
                                type='button'
                                onClick={() => handleReject(acct)}
                                className=" btn-primary align-center flex justify-center items-center rounded-md border border-transparent mr-4  px-8  py-2 text-sm font-medium text-white shadow-sm  sm:w-auto">Reject Application</button>
                              <button
                                type='button'
                                className='btn-secondary  align-center flex justify-center items-center rounded-md border px-8 py-2 text-sm font-medium text-black shadow-sm  sm:w-auto'
                                onClick={() => handleApprove(acct)}>Approve Application</button>
                            </div>
                          </> : ""}

                      </form>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </main>
        {/* Approve modal */}
        <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xs sm:w-full sm:p-6">
                    <div>
                      <div className="mt-3 text-center sm:mt-5">
                        <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                          Hey, wait!!
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            Are you sure you want approve this application?
                          </p>
                          <form>
                            <label htmlFor="comment" className="text-left mt-2 block text-sm font-medium text-gray-700">Comment</label>
                            <div className="mt-1">
                              <input
                                id="comment"
                                name="comment"
                                type="text"
                                placeholder='Enter comment'
                                autoComplete="text"
                                value={commentValue.comment}
                                onChange={formHandler.commentHandler}
                                required
                                className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              />
                              {!formState.commentIsValidated && formState.commentError && (
                                <div className="text-red-800">
                                  {formState.commentError}
                                </div>
                              )}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                      {loading.loading === false ?
                        <button
                          type="button"
                          className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                          onClick={(text) => approve(text)}
                        >
                          Yes, I do
                        </button> :
                        <HollowDotsSpinner size={15} color="#4D627E" />
                      }

                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                        onClick={() => setOpen(false)}

                        ref={cancelButtonRef}
                      >
                        No, I dont
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>

        <Transition.Root show={openReject} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleRejectClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xs sm:w-full sm:p-6">
                    <div>
                      <div className="mt-3 text-center sm:mt-5">
                        <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                          Hey, wait!!
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            Are you sure you want reject this application?
                          </p>
                          <form>
                            <label htmlFor="comment" className="text-left mt-2 block text-sm font-medium text-gray-700">Comment</label>
                            <div className="mt-1">
                              <input
                                id="comment"
                                name="comment"
                                type="text"
                                placeholder='Enter comment'
                                autoComplete="text"
                                value={commentValue.comment}
                                onChange={formHandler.commentHandler}
                                required
                                className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              />
                              {!formState.commentIsValidated && formState.commentError && (
                                <div className="text-red-800">
                                  {formState.commentError}
                                </div>
                              )}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                      {loading.loading === false ?
                        <button
                          type="button"
                          className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                          onClick={() => reject()}
                        >
                          Yes, I do
                        </button>
                        : <HollowDotsSpinner size={15} color="#4D627E" />}

                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                        onClick={() => setRejectOpen(false)}
                        ref={cancelButtonRef}
                      >
                        No, I dont
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </React.Fragment>
    </Layout>


  </>);
}